import { ENUM__grid2d_cell_size } from '@shared/dto/grid2d_cell/ENUM__grid2d_cell_size';
import { useMemo } from 'react';

export function HOOK_GRID2D_CELL__button_size(ui_grid2d_cell_size: string) {
  return useMemo(() => {
    return ui_grid2d_cell_size === ENUM__grid2d_cell_size.L ? 'size-[3rem]' : 'size-[2rem]';
  }, [ui_grid2d_cell_size]);
}
